import { InjectionToken, Signal } from '@angular/core';

export type SnackbarType = 'default' | 'success' | 'failure';

export interface SnackbarItem {
  readonly id: number;
  readonly message: string;
  readonly action: string;
  readonly type: SnackbarType;
  readonly duration: number;
  readonly paused: boolean;
  readonly cycle: number;
  readonly leaving: boolean;
}

export interface SnackbarHost {
  readonly items: Signal<readonly SnackbarItem[]>;
  dismiss(id: number): void;
  pauseTimer(id: number): void;
  resumeTimer(id: number): void;
}

export const SNACKBAR_HOST = new InjectionToken<SnackbarHost>('SNACKBAR_HOST');

export const SNACKBAR_LEAVE_ANIMATION_MS = 200;
